import { render, staticRenderFns } from "./viewlimits.vue?vue&type=template&id=617501eb"
import script from "./viewlimits.vue?vue&type=script&lang=js"
export * from "./viewlimits.vue?vue&type=script&lang=js"
import style0 from "./viewlimits.vue?vue&type=style&index=0&id=617501eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports